import Image from 'next/image';
import styled from 'styled-components';
import { DangerousInnerHTML } from '@/shared/components/dangerous-inner-html';
export const Wrapper = styled.div<{
  $background: string;
}>`
  background-size: cover !important;
  background-image: ${({
  $background
}) => $background ? `url(${$background})` : ''};
  padding-bottom: 3.5em;
  height: 100%;
  flex-grow: 1;
`;
export const Header = styled.div`
  max-width: 630px;
  width: 100%;
  margin: 20px auto 25px;

  @media screen and (min-width: 1441px) {
    max-width: 700px;
  }
`;
export const Logo = styled(Image)`
  display: block;
  margin: 0 auto 10px;
  max-width: 140px;
  width: 100%;
  height: auto;

  @media screen and (min-width: 1441px) {
    max-width: 160px;
  }
`;
export const Title = styled.h1`
  margin: 0 0 15px;
  color: #fff;
  font-size: 28px;
  line-height: 35px;
  text-align: center;
  text-transform: none;
  letter-spacing: 1px;

  @media screen and (min-width: 1441px) {
    font-size: 32px;
    line-height: 40px;
  }
`;
export const Description = styled.p`
  margin: 0 0 15px 0;
  font-size: 18px;
  line-height: 25px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-weight: 500;
  padding: 0 40px;

  @media screen and (min-width: 1441px) {
    font-size: 20px;
    line-height: 25px;
  }
`;
export const AdditionalText = styled(DangerousInnerHTML)`
  max-width: 590px;
  width: 100%;
  margin: 0 auto;
  padding: 10px 20px;
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ffe492;
  text-align: center;
`;